var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [{ name: "viewer", rawName: "v-viewer" }],
      staticClass: "userpic",
    },
    [
      _vm.url
        ? _c("img", { attrs: { src: _vm.url, alt: "" } })
        : _c("img", { attrs: { src: "/redesign/img/userpic.svg" } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }